import {IssuePersonalData} from "../domain/entities/issue-personal-data.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Changes ONLY `sortOrder` — pure position within the row's currently assigned
 * column, never touches `personalLabel`. See
 * `ReorderIssueOfPersonalLabelCommandHandler`. Deliberately does NOT trigger a
 * `MyOrganizerNotificationService` toast (ADR-014) — reordering within a column
 * is not a "business event" worth a notification.
 *
 * `mainEntityClass`/`mainEntityUid`: see `CreateIssuePersonalDataCommand`'s own
 * doc comment (must point at this row, never at the referenced Issue).
 */
export class ReorderIssueOfPersonalLabelCommand extends AbstractCommand<IssuePersonalData> {

    name = CommandName.REORDER_ISSUE_OF_PERSONAL_LABEL;

    tags = ['entity', 'reorder', 'issue-personal-data'];

}
